let msnry, zeroQuery = false, getQuery = true;


function updateMasonryLayout() {
    if (msnry) {
        msnry.layout();
    }
}

function initializeMasonry(id_grid) {
    if (msnry) {
        msnry.destroy();
    }

    const grid = jQuery(id_grid)[0];
    const images = grid.querySelectorAll('img');
    let imagesToLoad = images.length;

    if (imagesToLoad === 0) {
        initMasonry();
        return;
    }

    images.forEach(img => {
        if (img.complete) {
            imageLoaded();
        } else {
            img.addEventListener('load', imageLoaded);
            img.addEventListener('error', imageLoaded); // На случай ошибки загрузки
        }
    });

    function imageLoaded() {
        imagesToLoad--;
        if (imagesToLoad === 0) {
            initMasonry();
        }
    }

    function initMasonry() {
        msnry = new Masonry(grid, {
            itemSelector: ".portfolio__projects-item",
            percentPosition: true,
            columnWidth: ".portfolio__projects-item",
            isFitWidth: true,
            horizontalOrder: true,
            transitionDuration: "0.3s",
            stagger: 20
        });
        msnry.layout();
    }
}


var targetElement = document.getElementById('portfolio-grid');
var observer = new MutationObserver(function (mutationsList, observer) {
});
var config = {
    childList: true,
    subtree: true
};


document.addEventListener("DOMContentLoaded", function () {

    initializeMasonry("#portfolio-grid");
    window.addEventListener("resize", function () {
        updateMasonryLayout();
    });

    var productPortfolioSearchField = document.getElementById('portfolio-search-input');
    if (productPortfolioSearchField) {
        productPortfolioSearchField.addEventListener('input', debounce(getSearchSuggestionsPortfolio, 300));
    }

    jQuery(window).scroll(function () {
        getPositionLoadElement();
    });

    jQuery(window).on('resize', function () {
        getPositionLoadElement();
    });

    jQuery('.portfolio__container').on('click', '.portfolio__projects-dot', function (elem) {
        let pointElement = jQuery(this).closest('.portfolio__projects-interactive');
        elem.stopPropagation();
        if (!jQuery(pointElement).find('.portfolio__projects-info').is('.show')) {
            let currentProjectInfo = jQuery(pointElement).find('.portfolio__projects-info');

            setPositionLabel(jQuery(currentProjectInfo), 'right');
            jQuery(currentProjectInfo).addClass('show');

            const parentRect = jQuery(currentProjectInfo).closest('.portfolio-projects-item');

            const rect_top = parentRect.offset().top,
                rect_bottom = parentRect.offset().top + parentRect.outerHeight(),
                rect_right = parentRect.offset().left + parentRect.outerWidth(),
                rect_left = parentRect.offset().left;


            let position, label_top, label_bottom, label_right, label_left;

            function reloadPosition(interactive_label) {
                label_top = interactive_label.offset().top;
                label_bottom = interactive_label.offset().top + interactive_label.outerHeight();
                label_right = interactive_label.offset().left + interactive_label.outerWidth();
                label_left = interactive_label.offset().left;
            }

            reloadPosition(jQuery(currentProjectInfo));

            if (label_top < rect_top) {
                position = 'bottom';
                setPositionLabel(jQuery(currentProjectInfo), position);
                reloadPosition(jQuery(currentProjectInfo));
                if (label_right > rect_right) {
                    position = 'bottom_left';
                    setPositionLabel(jQuery(currentProjectInfo), position);
                } else if (label_left < rect_left) {
                    position = 'bottom_right';
                    setPositionLabel(jQuery(currentProjectInfo), position);
                }
            } else if (label_bottom > rect_bottom) {
                position = 'top';
                setPositionLabel(jQuery(currentProjectInfo), position);
                reloadPosition(jQuery(currentProjectInfo));
                if (label_right > rect_right) {
                    position = 'top_left';
                    setPositionLabel(jQuery(currentProjectInfo), position);
                } else if (label_left < rect_left) {
                    position = 'top_right';
                    setPositionLabel(jQuery(currentProjectInfo), position);
                }
            } else if (label_right > rect_right) {

                position = 'left';
                setPositionLabel(jQuery(currentProjectInfo), position);
                reloadPosition(jQuery(currentProjectInfo));

                if (label_left < rect_left) {
                    position = 'top';
                    setPositionLabel(jQuery(currentProjectInfo), position);
                    reloadPosition(jQuery(currentProjectInfo));
                    // Выполним проверку на отступ сверху, вдруг там тоже нет места
                    if (label_top < rect_top) {
                        position = 'bottom';
                        setPositionLabel(jQuery(currentProjectInfo), position);
                    }
                } else if (label_top < rect_top) {
                    position = 'bottom_left';
                    setPositionLabel(jQuery(currentProjectInfo), position);
                } else if (label_bottom > rect_bottom) {
                    position = 'top_left';
                    setPositionLabel(jQuery(currentProjectInfo), position);
                }
            } else if (label_left < rect_left) {
                position = 'right';
                setPositionLabel(jQuery(currentProjectInfo), position);
                reloadPosition(jQuery(currentProjectInfo));
                if (label_top < rect_top) {
                    position = 'bottom_right';
                    setPositionLabel(jQuery(currentProjectInfo), position);
                } else if (label_bottom > rect_bottom) {
                    position = 'top_right';
                    setPositionLabel(jQuery(currentProjectInfo), position);
                }
            }
        } else {
            jQuery(pointElement).find('.portfolio__projects-info').removeClass('show');
        }
    });

    jQuery('.portfolio__container').on('click', '.portfolio__projects-info', function (elem) {
        elem.stopPropagation();
        elem.preventDefault();
        let current_link = jQuery(this).attr('href');
        let current_id_fabric = jQuery(this).data('fabric');
        if (current_id_fabric) {
            if (!localStorage['favoriteFabrics'] || !Array.isArray(JSON.parse(localStorage['favoriteFabrics']))) {
                localStorage['favoriteFabrics'] = JSON.stringify([current_id_fabric]);
            } else if (JSON.parse(localStorage['favoriteFabrics']).includes(current_id_fabric)) {
                var array = JSON.parse(localStorage['favoriteFabrics']);
                array.splice(JSON.parse(localStorage['favoriteFabrics']).indexOf(current_id_fabric), 1);
                localStorage['favoriteFabrics'] = JSON.stringify(array);
            } else {
                var _array = JSON.parse(localStorage['favoriteFabrics']);
                _array.unshift(current_id_fabric);
                if (_array.length > 5) {
                    _array.pop();
                }
                localStorage['favoriteFabrics'] = JSON.stringify(_array);
            }
            window.open(current_link, '_blank');
        } else {
            window.open(current_link, '_blank');
        }
    });


// Обработчик для открытия модального окна при клике на изображение
    jQuery('.portfolio__container').on('click', '.portfolio-projects-item.search-item-potfolio', function () {
        let portfolio_id = jQuery(this).attr("id").split('-', 2);
        let modal_id = 'modal-' + portfolio_id[1];
        document.getElementById(modal_id).style.display = 'flex';
        document.body.classList.add('stop-scroll');
    });


    document.querySelectorAll('.portfolio-modal__close-btn').forEach(item => {
        item.addEventListener('click', function () {
            this.closest('.portfolio-modal').style.display = 'none';
            document.body.classList.remove('stop-scroll');
        });
    });


    jQuery('a.variations-item').on('click', function (link) {
        link.preventDefault();
        let current_link = jQuery(this).attr('href');
        let current_id_fabric = jQuery(this).data('fabric');
        if (current_id_fabric) {
            if (!localStorage['favoriteFabrics'] || !Array.isArray(JSON.parse(localStorage['favoriteFabrics']))) {
                localStorage['favoriteFabrics'] = JSON.stringify([current_id_fabric]);
            } else if (JSON.parse(localStorage['favoriteFabrics']).includes(current_id_fabric)) {
                var array = JSON.parse(localStorage['favoriteFabrics']);
                array.splice(JSON.parse(localStorage['favoriteFabrics']).indexOf(current_id_fabric), 1);
                localStorage['favoriteFabrics'] = JSON.stringify(array);
            } else {
                var _array = JSON.parse(localStorage['favoriteFabrics']);
                _array.unshift(current_id_fabric);
                if (_array.length > 5) {
                    _array.pop();
                }
                localStorage['favoriteFabrics'] = JSON.stringify(_array);
            }
            window.open(current_link, '_blank');
        } else {
            window.open(current_link, '_blank');
        }
    });

});


async function getSearchSuggestionsPortfolio(event) {
    let searchStr = event.target.value.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    jQuery('.portfolio__filter-list .portfolio__filter-item:nth-child(1)').trigger('click');
    function waitForStyles() {
        if (document.readyState === 'complete') {
            initializeMasonry("#portfolio-grid-search");
        } else {
            requestAnimationFrame(waitForStyles);
        }
    }
    if (searchStr.length != 0) {
        jQuery("#loadmore").addClass('inactive');
        zeroQuery = false;
        jQuery(".waiting-search-response").addClass('show');
        jQuery("#portfolio-grid").addClass('transition-load');
        await fetch(location.origin + '/wp-content/themes/savoy-child/includes/search_portfolio.php', {
            method: 'POST',
            headers: {'Content-Type': 'application/json;charset=utf-8'},
            body: JSON.stringify(searchStr)
        }).then(function (response) {
            return response.text();
        }).then(function (data) {
            data = JSON.parse(data);
            jQuery("#portfolio-grid-search .portfolio-projects-item.search-item-potfolio").each(function () {
                jQuery(this).remove();
            });
            jQuery("#portfolio-grid-search").append(data);
            let RenderGrid = function () {
                if (!zeroQuery) {
                    jQuery("#portfolio-grid").addClass('hide');
                    jQuery("#portfolio-grid").removeClass('transition-load');
                    jQuery(".waiting-search-response").removeClass('show');
                    jQuery("#portfolio-grid-search").removeClass('hide');
                    waitForStyles();
                    return true;
                } else {
                    return false;
                }
            };
            RenderGrid();
        })["catch"](function (err) {
            console.error('Failed to fetch page: ', err);
        });
    } else if (searchStr.length == 0) {
        zeroQuery = true;
        jQuery("#loadmore").removeClass('inactive');
        jQuery("#portfolio-grid-search").addClass('hide');
        jQuery(".waiting-search-response").removeClass('show');
        jQuery("#portfolio-grid").removeClass('hide');
        jQuery("#portfolio-grid").removeClass('transition-load');
        waitForStyles();
    }
}

// открывашка списка

if(document.querySelector('.portfolio__filter-toggle')) {
    document.querySelector('.portfolio__filter-toggle').addEventListener('click', function () {
        const filterList = document.querySelector('.portfolio__filter-list');
        filterList.classList.toggle('expanded');
        const toggleText = document.querySelector('.portfolio__filter-toggle-text');
        if (filterList.classList.contains('expanded')) {
            toggleText.textContent = 'Скрыть';
        } else {
            toggleText.textContent = 'Раскрыть';
        }
        this.classList.toggle('expanded');
    });
}





// Фильтрация по табам
function filtredPortfolioItems(category_name) {
    jQuery(".portfolio-projects-item").each(function () {

        if (jQuery(this).hasClass('not-found-block')) {
            return true
        }
        let current_attr = JSON.parse(jQuery(this).attr('data-category'));
        if (category_name == 'all') {
            jQuery(this).css('display', 'flex');
            jQuery(this).addClass('portfolio__projects-item');
        } else if (current_attr.includes(category_name) && category_name != 'all') {
            jQuery(this).css('display', 'flex');
            jQuery(this).addClass('portfolio__projects-item');
        } else {
            jQuery(this).css('display', 'none');
            jQuery(this).removeClass('portfolio__projects-item');
        }
    });
}


let filtredStatusPortfolio = 1;
if(filtredStatusPortfolio) {
    jQuery('.portfolio__filter-item:not(.filter-not-ready)').on('click', function () {
        filtredStatusPortfolio = 0;
        let current_atr = jQuery(this).attr('data-filtred');
        jQuery('.portfolio__filter-item').each(function () {
            jQuery(this).removeClass('portfolio__filter-item--active');
            jQuery(this).addClass('filter-not-ready');
        });
        jQuery(this).addClass('portfolio__filter-item--active');
        if (jQuery(".portfolio-projects-item")) {
            filtredPortfolioItems(current_atr);
            updateMasonryLayout();
            filtredStatusPortfolio = 1;
            jQuery('.portfolio__filter-item').each(function () {
                jQuery(this).removeClass('filter-not-ready');
            });
        }
    });
}


// плашки

function setPositionLabel(label, position) {
    let top, bottom, right, left,
        top_right, top_left, bottom_right, bottom_left;
    top = {left: 'calc(-50% + 16px)', transform: 'translateY(calc(-100% - 40px))',};
    bottom = {left: 'calc(-50% + 16px)', transform: 'translateY(8px)',};
    right = {left: '40px', transform: 'translateY(calc(-50% - 16px))',};
    left = {left: 'calc(-100% - 8px)', transform: 'translateY(calc(-50% - 16px))',};
    top_right = {left: '40px', transform: 'translateY(calc(-100% - 40px))',};
    top_left = {left: 'calc(-100% - 8px)', transform: 'translateY(calc(-100% - 40px))',};
    bottom_right = {left: '40px', transform: 'translateY(8px)',};
    bottom_left = {left: 'calc(-100% - 8px)', transform: 'translateY(8px)',};

    if (position === 'top') {
        position = top;
    } else if (position === 'bottom') {
        position = bottom;
    } else if (position === 'right') {
        position = right;
    } else if (position === 'left') {
        position = left;
    } else if (position === 'top_right') {
        position = top_right;
    } else if (position === 'top_left') {
        position = top_left;
    } else if (position === 'bottom_right') {
        position = bottom_right;
    } else if (position === 'bottom_left') {
        position = bottom_left;
    }
    jQuery(label).css('left', position.left);
    jQuery(label).css('transform', position.transform);

}

function getPortfolioItems() {

    function stringToHTML(htmlString) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        return Array.from(doc.body.children);
    }

    let url = new URL(ajaxurl),
        button = jQuery('#loadmore'),
        paged = button.data('paged'),
        maxPages = button.data('max_pages');
    url.searchParams.append('action', 'get_portfolio_item');
    jQuery.ajax({
        type: 'POST',
        url: url,
        data: {paged: paged},
        success: function (data) {
            paged++;
            button.data('paged', paged);
            if (paged > maxPages) {
                button.remove();
                getPositionLoadElement = function (passed) {};
            }

            data.data.forEach((item) => {
                item = JSON.parse(item);
                const newItem = document.createElement('div');
                newItem.classList.add('portfolio__projects-item');
                newItem.classList.add('portfolio-projects-item');
                newItem.classList.add('search-item-potfolio');
                newItem.setAttribute('id', 'portfolio-'+item.id);
                newItem.setAttribute('data-category', item.dataсategory);

                const img = document.createElement('img');
                img.src = item.image;

                const  xmlContentList = stringToHTML(item.moreсhild);
                newItem.appendChild(img);
                xmlContentList.forEach((item) => {
                    newItem.appendChild(item)
                })

                img.addEventListener('load', () => {
                    document.getElementById("portfolio-grid").appendChild(newItem);
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            msnry.appended(newItem);
                        });
                    });
                });

                // Добавляем обработчик ошибки загрузки
                img.addEventListener('error', () => {
                    console.error('Изображение не загрузилось');
                });
            });
            msnry.layout();

        },
        complete: function () {
            jQuery('.portfolio__filter-item').each(function () {
                if (jQuery(this).hasClass('portfolio__filter-item--active')) {
                    jQuery(this).trigger('click');
                }
            });
            jQuery(".waiting-search-response").removeClass('show');
            getQuery = true;
        }
    });
}

function getPositionLoadElement() {
    if (jQuery('#loadmore')) {
        let wt = jQuery(window).scrollTop();
        let wh = jQuery(window).height();
        let et = jQuery('#loadmore').offset().top;
        let eh = jQuery('#loadmore').outerHeight();
        let dh = jQuery(document).height();
        if ((wt + wh >= et || wh + wt == dh || eh + et < wh) && getQuery == true && !jQuery('#loadmore').hasClass('inactive')) {
            getQuery = false;
            jQuery(".waiting-search-response").addClass('show');
            getPortfolioItems();
        }
    } else {
        return true;
    }
}
